import React from 'react';
import Chatbot from './components/Chatbot';
import UpdateSitePrices from './components/UpdateSitePrices';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

function App() {
  return (
     <Router>
      <Routes>
        <Route path="/" element={<Chatbot />} />
        <Route path="/UpdateSitePrices" element={<UpdateSitePrices />} />
      </Routes>
    </Router>
  );
}

export default App;
